module.exports = __webpack_public_path__ + "img/project15_1.jpg.418233a3.webp";